exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading[data-v-2d567e1f]{color:#006b8d;border-bottom:2px solid #006b8d!important}.panel-heading h4[data-v-2d567e1f]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-2d567e1f]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d567e1f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/makeNewOrder.vue
// module id = 759
// module chunks = 0